import { IonItem, IonInput, IonInputPasswordToggle, IonIcon, IonCardContent } from "@ionic/react";
import { eyeOff, eye} from "ionicons/icons"
import { EyeIcon } from "@heroicons/react/24/outline";
import { useContext } from "react";
import { UserContext } from "../Context/UserContext";
export default function Input(props) {
  const {name, type, label, className, value, onChange, togglePassword, myHidePwd} = props;
  const {darkTheme} = useContext(UserContext);
  return (
    <IonCardContent className="py-0 mb-1 flex items-center">
      <IonInput
        {...props}
        type={type}
        label={label}
        labelPlacement="floating"
        className={`text-[18px] font-bold ${darkTheme ? "bg-gray-700 text-[#333a]" : "bg-slate-50 text-[#333a]"} ${className}`}
        value={value}
        onIonInput={onChange}
        name={name}
      />
      {togglePassword && (
        // <IonInputPasswordToggle onClick={()=>togglePassword()} slot="end" class="text-slate-900">666</IonInputPasswordToggle>
        // <IonIcon icon={eye} slot="end" onClick={()=>togglePassword()} className="text-slate-400" />
        // {type==="password" && <EyeIcon icon={eye} slot="end" onClick={()=>togglePassword()} />}
        <EyeIcon icon={eye} slot="end" onClick={()=>togglePassword()} className="w-6 h-6 text-slate-400 bg-gray-50" />
      )}
    </IonCardContent>
  );
}
